import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Apiurl from '../../../Helpers/apiUrl';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

// Helper function to replace date-fns formatDistanceToNow
const timeAgo = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    
    let interval = seconds / 31536000;
    if (interval > 1) return Math.floor(interval) + " years ago";
    interval = seconds / 2592000;
    if (interval > 1) return Math.floor(interval) + " months ago";
    interval = seconds / 86400;
    if (interval > 1) return Math.floor(interval) + " days ago";
    interval = seconds / 3600;
    if (interval > 1) return Math.floor(interval) + " hours ago";
    interval = seconds / 60;
    if (interval > 1) return Math.floor(interval) + " minutes ago";
    return Math.floor(seconds) + " seconds ago";
};

const LivePulseFeed = () => {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchActivities = async () => {
        try {
            const token = localStorage.getItem("u_token");
            const response = await axios.get(`${Apiurl}admin/live-pulse?t=${Date.now()}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data?.status === 'success') {
                setActivities(response.data.data);
            }
        } catch (error) {
            console.error('Failed to fetch live pulse data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchActivities();
        const interval = setInterval(fetchActivities, 5000); // Poll every 5 seconds
        return () => clearInterval(interval);
    }, []);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0
        }).format(amount);
    };

    return (
        <div className="bg-white/60 backdrop-blur-md rounded-2xl border border-slate-100 p-4 h-[400px] flex flex-col shadow-sm" style={{ boxShadow: '0 1px 4px rgba(10,37,64,0.06)' }}>
            <div className="flex items-center gap-2 mb-4 text-blue-600">
                <NotificationsActiveIcon sx={{ fontSize: 20 }} className="animate-pulse" />
                <h3 className="font-semibold text-lg text-slate-800">Live Pulse</h3>
                <span className="ml-auto text-[10px] bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full font-bold uppercase tracking-wide animate-pulse">Live</span>
            </div>

            <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar">
                {loading && activities.length === 0 ? (
                    <div className="flex items-center justify-center h-full text-slate-400 text-sm">Loading activity...</div>
                ) : activities.length === 0 ? (
                    <div className="flex items-center justify-center h-full text-slate-400 text-sm">No recent activity.</div>
                ) : (
                    <div className="flex flex-col gap-3">
                        {activities.map((activity) => (
                            <div
                                key={activity.id}
                                className="pulse-item bg-white p-3 rounded-xl border border-slate-100 shadow-sm relative overflow-hidden group"
                            >
                                <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-500 rounded-l-xl"></div>
                                <div className="flex justify-between items-start mb-1 pl-1">
                                    <p className="text-sm font-semibold text-slate-800 line-clamp-1 pr-2">
                                        {activity.user_name} <span className="font-normal text-slate-500">{activity.action === 'updated' ? 'updated' : 'created'} a quote for</span> {activity.client_name}
                                    </p>
                                </div>
                                <div className="flex justify-between items-end mt-2 pl-1">
                                    <div className="flex flex-col">
                                        <span className="text-[10px] font-medium text-slate-400 uppercase tracking-wider">{activity.role_name} • {activity.user_state}</span>
                                        <span className="text-xs text-slate-500 mt-0.5">
                                            {timeAgo(activity.action_date || activity.created_at)}
                                        </span>
                                    </div>
                                    <span className="text-sm font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md">
                                        {formatCurrency(activity.sub_total)}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <style jsx>{`
                .custom-scrollbar::-webkit-scrollbar {
                    width: 4px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: rgba(0,0,0,0.1);
                    border-radius: 4px;
                }
                .pulse-item {
                    animation: slideDown 0.4s ease-out forwards;
                }
                @keyframes slideDown {
                    from { opacity: 0; transform: translateY(-10px) scale(0.98); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }
            `}</style>
        </div>
    );
};

export default LivePulseFeed;
